import React, { Component, FormEvent, ReactNode } from 'react';
import { FormicaProps, withFormica } from '../../../helpers/withFormica';
import { dispatch, RootState } from '../../../redux/store';
import { changeStruct } from '../../../redux/actions/StructActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import {
  ArrayVariableProperties,
  CustomStructureProperties,
  DateVariableProperties,
  EntryProperties,
  VariableProperties,
} from '../../../domain/datatype/VariablePropertiesDomains';
import DataType from '../../../constant/DataType';
import Icon from '../../../icons/Icon';
import { query, repository, subscribe } from '@trlogic/client-js';
import { InstanceContainer } from '../../../config/binding/InstanceBinding';
import Injectables from '../../../constant/Injectables';
import CollectionNames from '../../../constant/CollectionNames';
import { customConfirm } from '../../custom/CustomPopupConfirm';
import RoleHelper from '../../../RoleHelper';
import MessageUtil from '../../../util/MessageUtil';
import { isStringValid } from '../../../util/Generator';
import FormicaInput from '../../custom/FormicaInput';
import ComponentName from '../../../constant/ComponentName';
import { ComponentDependency } from '../../../domain/ui/ComponentMetadata';
import { openBulkActionDialogFromDependency } from '../../../redux/actions/BulkActionActions';
import DataTypeSelectBoxComponent from '../../custom/DataTypeSelectBoxComponent';
import { FormicaSelectBoxItem } from '../../custom/FormicaSearchSelectBox';
import CustomLoading from '../../custom/CustomLoading';
import QueryBuilder = query.QueryBuilder;
import and = query.and;
import eq = query.eq;
import LanguageUtil from '../../../util/LanguageUtil';

class StructCreateComponent extends Component<Props, State> {
  public state = new State();
  private repository: repository.ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);

  private dataTypeSubscription: subscribe.Subscription | undefined;
  private computation: subscribe.Computation | undefined;

  public render(): ReactNode {
    const { loading } = this.state;
    const {
      struct: { struct, isUpdate },
    } = this.props;

    if (loading) {
      return <CustomLoading />;
    }
    return (
      struct.properties?.dataType == DataType.OBJECT && (
        <div id={'struct-create-component'} className={'flex flex-col w-full h-full items-start justify-start overflow-y-scroll gap-y-5 py-2 px-5'}>
          {<p className={'text-f-black-3 sticky'}>object{`{${struct.properties.variables.length}}`}</p>}
          {struct.properties.variables.length <= 0 && (
            <div
              className={
                'rounded gap-y-5 border text-black border-[#0D99FF] self-center px-3 py-3 w-1/4 hover:border-1 flex items-center justify-center  transition-opacity hover:cursor-pointer '
              }
              onClick={() => this.addNewVariable(0)}
              data-testid={`${ComponentName.STRUCT}_add_new_variable_button`}
            >
              Add a new variable
              <Icon icon={'add'} size={16} />
            </div>
          )}
          {struct.properties &&
            struct.properties.variables &&
            struct.properties.variables.length > 0 &&
            struct.properties.variables.map((variable: EntryProperties | any, index: number) => {
              return (
                <div
                  key={index}
                  className={`flex flex-col w-full bg-transparent text-md group ${!isUpdate ? 'hover:cursor-pointer' : 'hover:cursor-default'} w-full gap-y-5`}
                >
                  <div
                    className={'flex items-center justify-start gap-x-5 '}
                    onBlur={() => this.setState({ selectedVariable: null })}
                    onClick={() => this.setState({ selectedVariable: variable })}
                  >
                    <FormicaInput
                      disabled={!RoleHelper.canEdit('Struct')}
                      onChange={async (e) => this.onVariableNameChange(variable, e)}
                      onBlur={(e) => this.onBlurVariableName(e, index)}
                      value={variable.name}
                      placeholder={LanguageUtil.get({ id: `common.input.placeholder.key`, defaultMessage: 'Key' })}
                      className={`cursor-pointer px-1.5 py-1.5 rounded`}
                      data-testid={`${ComponentName.STRUCT}_variable_name_input`}
                    />
                    :
                    <DataTypeSelectBoxComponent
                      properties={variable.properties}
                      onChangeValue={(value: FormicaSelectBoxItem) => this.onVariableDataTypeChange(variable, value)}
                      disabled={!RoleHelper.canEdit('Struct')}
                      data-testid={`${ComponentName.STRUCT}_variable_data_type_select_box`}
                    />
                    {(variable.properties.dataType == DataType.DATE ||
                      (variable.properties.dataType == DataType.ARRAY &&
                        (variable.properties as ArrayVariableProperties).properties.dataType == DataType.DATE)) && (
                      <div className={'flex items-center w-full gap-x-2 justify-start'}>
                        :
                        <FormicaInput
                          disabled={!RoleHelper.canEdit('Struct')}
                          onChange={(e) => this.onChangeDateVariableFormat(e, variable)}
                          value={this.getVariableDateFormat(variable)}
                          placeholder={LanguageUtil.get({ id: `common.input.placeholder.dateFormat`, defaultMessage: 'Date Format' })}
                        />
                      </div>
                    )}
                    <div
                      className={'hover:cursor-pointer'}
                      onClick={(e: React.MouseEvent<HTMLDivElement>) => this.onRemoveVariable(e, variable)}
                      data-testid={`${ComponentName.STRUCT}_variable_remove_button`}
                    >
                      <Icon icon={'multiplier'} size={16} />
                    </div>
                  </div>
                  {index == struct.properties.variables.length - 1 && (
                    <div
                      className={
                        '!bg-white rounded-[4px] h-6 border-f-purple text-f-purple border flex items-center justify-center opacity-40 hover:opacity-100 transition-opacity'
                      }
                      data-testid={`${ComponentName.STRUCT}_add_new_variable_button`}
                      onClick={() => this.addNewVariable(index + 1)}
                    >
                      +
                    </div>
                  )}
                </div>
              );
            })}
        </div>
      )
    );
  }

  public async componentDidMount() {
    await this.startTracker();
  }

  public async componentWillUnmount() {
    await this.stopTracker();
  }

  private startTracker = async () => {
    const dataTypeQuery = query.QueryBuilder.select().from(CollectionNames.DATA_STRUCTURES);
    this.dataTypeSubscription = subscribe.Formica.subscribe(CollectionNames.DATA_STRUCTURES, dataTypeQuery.build());
    this.computation = subscribe.Tracker.autorun(this.tracker, [this.dataTypeSubscription]);
  };

  private tracker = async () => {
    if (this.dataTypeSubscription?.ready()) {
      this.setState({ loading: false });
    }
  };

  private stopTracker = async () => {
    await this.dataTypeSubscription?.stop();
    this.computation?.stop();
  };

  private addNewVariable = async (index: number) => {
    const {
      struct: { struct },
      changeStruct,
      prepare,
    } = this.props;
    if (!RoleHelper.canEdit('Struct')) return;
    struct.properties.variables.splice(index, 0, {
      name: 'Key' + (struct.properties.variables.length + 1),
      properties: {
        dataType: DataType.STRING,
      },
      description: '',
    } as EntryProperties);
    changeStruct(struct);
    prepare();
  };

  private deleteVariable = async (variable: EntryProperties) => {
    const {
      struct: { struct },
      prepare,
    } = this.props;
    if (!RoleHelper.canEdit('Struct')) return;
    const dependencies: ComponentDependency[] = await this.repository.findMany(
      QueryBuilder.select()
        .from(CollectionNames.COMPONENT_DEPENDENCY)
        .where(and(eq('dependentType', ComponentName.STRUCT_FIELD), eq('meta.struct', struct.name)))
        .build(),
    );
    if (dependencies.length > 0) {
      dispatch(openBulkActionDialogFromDependency({ id: variable.name, reason: 'DELETE', dependencies: dependencies, status: false }, ComponentName.STRUCT));
      return;
    }
    struct.properties.variables = struct.properties.variables.filter((v: EntryProperties) => v != variable);
    prepare();
  };

  private onVariableNameChange = async (variable: EntryProperties, event: any) => {
    const {
      struct: { struct },
      changeStruct,
      prepare,
    } = this.props;
    if (isStringValid(event.currentTarget.value)) {
      variable.name = event.currentTarget.value;
    } else {
      MessageUtil.warning({
        content: LanguageUtil.get({ id: 'messages.confirm.isNotValid', defaultMessage: 'Variable name is not valid' }),
      });
    }
    changeStruct(struct);
    prepare();
  };

  private onVariableDataTypeChange = (variable: EntryProperties, value: FormicaSelectBoxItem) => {
    const {
      struct: { struct },
      changeStruct,
      prepare,
    } = this.props;
    const properties = value.properties;
    if (properties == undefined) return;
    switch (properties.dataType) {
      case DataType.DATE:
        const prop: DateVariableProperties = {
          dataType: DataType.DATE,
          format: 'yyyy-MM-dd',
        };
        variable.properties = prop;
        break;
      default:
        variable.properties = properties;
    }
    changeStruct(struct);
    prepare();
  };

  private onChangeDateVariableFormat = (e: FormEvent<HTMLInputElement>, variable: EntryProperties) => {
    const {
      struct: { struct },
      changeStruct,
      prepare,
    } = this.props;
    if (variable.properties.dataType == DataType.DATE) {
      (variable.properties as DateVariableProperties).format = e.currentTarget.value;
    } else if (variable.properties.dataType == DataType.ARRAY && (variable.properties as ArrayVariableProperties).properties.dataType == DataType.DATE) {
      ((variable.properties as ArrayVariableProperties).properties as DateVariableProperties).format = e.currentTarget.value;
    }
    changeStruct(struct);
    prepare();
  };

  private getDataTypeName = (properties: VariableProperties): string => {
    if (properties.dataType == DataType.STRUCTURE) {
      return (properties as CustomStructureProperties).name;
    } else if (properties.dataType == DataType.ARRAY) {
      return `${this.getDataTypeName((properties as ArrayVariableProperties).properties)} - List`;
    }
    return properties.dataType;
  };

  private onBlurVariableName(event: React.FocusEvent, index: number) {
    const {
      struct: { struct },
      changeStruct,
      prepare,
    } = this.props;
    const variable = struct.properties.variables[index];
    const isVariableUnique = struct.properties.variables.filter((v: EntryProperties) => v.name == variable.name).length == 1;
    if (!isVariableUnique) {
      variable.name = LanguageUtil.get({ id: 'messages.mustBeUnique' });
      MessageUtil.warning({
        content: LanguageUtil.get({ id: 'messages.variableMustBeUnique', defaultMessage: 'Variable name must be unique' }),
      });
    }
    if (variable.name == '' || variable.name.trim() == '') {
      variable.name = 'Key' + (index + 1);
      changeStruct(struct);
      prepare();
      MessageUtil.warning({
        content: LanguageUtil.get({ id: 'messages.variableNameCannotEmpty', defaultMessage: 'Variable name cannot be empty' }),
      });
    }
  }

  private getVariableDateFormat(variable: EntryProperties) {
    const properties = variable.properties;
    if (properties.dataType == DataType.DATE) {
      return (properties as DateVariableProperties).format;
    }
    if (properties.dataType == DataType.ARRAY && (properties as ArrayVariableProperties).properties.dataType == DataType.DATE) {
      return ((properties as ArrayVariableProperties).properties as DateVariableProperties).format;
    }
    return undefined;
  }

  private onRemoveVariable = (e: React.MouseEvent<HTMLDivElement>, variable: EntryProperties) => {
    if (!RoleHelper.canEdit('Struct')) return;
    customConfirm({
      target: e.currentTarget,
      accept: () => this.deleteVariable(variable),
      message: LanguageUtil.get({ id: 'messages.confirm.removeVariable', defaultMessage: 'Are you sure remove this variable?' }),
    });
  };
}

interface Props extends FormicaProps, ReduxProps {
  prepare: VoidFunction;
}

class State {
  selectedVariable: EntryProperties | null = null;
  loading: boolean = true;
}

const mapStateToProps = (state: RootState) => ({
  struct: state.struct,
  isUpdate: state.struct.isUpdate,
});
const mapDispatchToProps = { changeStruct };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export default withFormica(connector(StructCreateComponent));
